/**
 * Fluxos da secao "Automação na prática".
 *
 * Dados dos 4 nichos: etapas (id, tipo, icone, titulo, conteudo)
 * consumidos pelo FluxoVertical (mobile/tablet) e pela lista sr-only. No
 * desktop cada nicho e renderizado por um FluxoCanvas* dedicado que ignora
 * este contrato — ver tabela abaixo.
 *
 * Estado atual dos 4 nichos — todos com layout dedicado no desktop:
 *   Pizzaria      FluxoCanvasPizzaria (storytelling visual + IA)
 *   Salao         FluxoCanvasSalao (storytelling visual + IA)
 *   Assistencia   FluxoCanvasAssistencia (100% humano — sem IA)
 *   Lava Jato     FluxoCanvasLavaJato (storytelling visual + IA)
 *
 * Os 4 layouts dedicados sao hardcoded em seus proprios componentes e nao
 * consomem as etapas definidas aqui — mas o array etapas ainda e usado pelo
 * FluxoVertical (mobile/tablet, abaixo de 1280px) e pela lista sr-only da
 * SecaoAutomacaoVisual, entao mantem os 4 nichos com etapas completas.
 *
 * NoFluxo (e MioloNo internamente) sao os componentes que o FluxoVertical
 * usa pra renderizar as etapas no mobile/tablet, empilhadas em largura total.
 *
 * Superficie publica do modulo: FLUXOS e SEQUENCIA.
 *
 * Contrato de cada etapa: { id, tipo, icone, titulo, conteudo?, papel?,
 * descricao? }.
 */

// Ordem em que a operacao acontece — dirige a execucao sequencial (um card
// ativo por vez) e a leitura por leitor de tela. O ramo "alternativa" fica
// fora: e caminho de excecao, acende com a decisao.
export const SEQUENCIA = ["cliente", "ia", "sistema", "decisao", "acao", "humano", "sucesso"];

export const FLUXOS = [
  /* ============================ VENDA E DELIVERY ============================ */
  {
    id: "pizzaria",
    nome: "Pizzaria / Delivery",
    icone: "Pizza",
    descricao: "Do pedido no WhatsApp à entrega na porta.",
    etapas: [
      {
        id: "cliente", tipo: "cliente", icone: "MessageCircle",
        titulo: "Cliente faz o pedido",
        conteudo: { layout: "conversa", autor: "Marcos A.", hora: "19:42", mensagem: "Quero uma pizza grande de calabresa" },
      },
      {
        id: "ia", tipo: "ia", icone: "Bot",
        titulo: "IA do Evolzap responde",
        conteudo: { layout: "resposta", resposta: "Olá! Temos sim 😊 Deseja adicionar mais algum item?", selo: "Respondendo em segundos" },
      },
      {
        id: "sistema", tipo: "sistema", icone: "Package",
        titulo: "Verifica estoque", papel: "Estoque",
        conteudo: {
          layout: "checklist",
          itens: [
            { nome: "Pizza calabresa G", status: "ok" },
            { nome: "Refrigerante 2L", status: "ok" },
            { nome: "Sobremesa", status: "ok" },
          ],
        },
      },
      {
        id: "decisao", tipo: "decisao", icone: "GitBranch",
        titulo: "Produto disponível?",
        conteudo: {
          layout: "decisao",
          saidas: [
            { rotulo: "sim", destino: "Fecha a venda", positivo: true },
            { rotulo: "não", destino: "Sugere alternativa", positivo: false },
          ],
        },
      },
      {
        id: "acao", tipo: "acao", icone: "Receipt",
        titulo: "Venda confirmada", papel: "Venda",
        conteudo: { layout: "ficha", titulo: "Pedido #1258", valor: "R$ 89,90", selo: "Pix", status: "Pagamento aprovado" },
      },
      {
        id: "alternativa", tipo: "ia", icone: "RefreshCw",
        titulo: "Sugere alternativa",
        conteudo: { layout: "resposta", resposta: "A calabresa acabou. Que tal portuguesa ou frango c/ catupiry?" },
      },
      {
        id: "humano", tipo: "humano", icone: "ChefHat",
        titulo: "Encaminha para a equipe", papel: "Cozinha",
        conteudo: { layout: "notificacao", notificacao: "Novo pedido na cozinha", detalhe: "#1258 — Pizza calabresa G", status: "Em preparo", equipe: ["JS", "RC"] },
      },
      {
        id: "sucesso", tipo: "sucesso", icone: "CheckCircle2",
        titulo: "Cliente recebe",
        conteudo: { layout: "conclusao", mensagem: "Pedido entregue! Bom apetite 🍕", meta: "entregue em", destaque: "32 min", avaliacao: 5 },
      },
    ],
  },

  /* ============================== AGENDAMENTO ============================== */
  {
    id: "salao",
    nome: "Salão de Beleza",
    icone: "Scissors",
    descricao: "Do pedido de horário ao lembrete automático.",
    etapas: [
      {
        id: "cliente", tipo: "cliente", icone: "MessageCircle",
        titulo: "Cliente pede horário",
        conteudo: { layout: "conversa", autor: "Carla M.", hora: "10:14", mensagem: "Gostaria de marcar corte amanhã." },
      },
      {
        id: "ia", tipo: "ia", icone: "Bot",
        titulo: "IA identifica o serviço",
        conteudo: {
          layout: "resposta",
          resposta: "Claro! Qual horário você prefere?",
          etiquetas: ["Corte masculino", "Amanhã"],
        },
      },
      {
        id: "sistema", tipo: "sistema", icone: "CalendarDays",
        titulo: "Consulta a agenda", papel: "Agenda",
        conteudo: {
          layout: "agenda",
          cabecalho: "Corte masculino",
          profissional: "João",
          horarios: [
            { hora: "14:00", alvo: true },
            { hora: "14:30", livre: false },
            { hora: "15:00" },
            { hora: "16:30" },
          ],
        },
      },
      {
        id: "decisao", tipo: "decisao", icone: "GitBranch",
        titulo: "Horário disponível?",
        conteudo: {
          layout: "decisao",
          saidas: [
            { rotulo: "sim", destino: "Confirma o horário", positivo: true },
            { rotulo: "não", destino: "Oferece outro", positivo: false },
          ],
        },
      },
      {
        id: "acao", tipo: "acao", icone: "CalendarCheck",
        titulo: "Agendamento confirmado", papel: "Reserva",
        conteudo: {
          layout: "ficha",
          titulo: "Corte masculino — João",
          linhas: [
            { rotulo: "Quando", valor: "Amanhã, 14:00" },
          ],
          status: "Confirmado",
        },
      },
      {
        id: "alternativa", tipo: "ia", icone: "RefreshCw",
        titulo: "Oferece outro horário",
        conteudo: { layout: "resposta", resposta: "14h ficou preenchido. Tenho 15:00 ou 16:30 com o João." },
      },
      {
        id: "humano", tipo: "humano", icone: "UserRound",
        titulo: "Profissional avisado", papel: "Profissional",
        conteudo: { layout: "notificacao", notificacao: "Novo agendamento", detalhe: "Carla M. — Corte, 14:00", status: "Agenda atualizada", equipe: ["JO"] },
      },
      {
        id: "sucesso", tipo: "sucesso", icone: "BellRing",
        titulo: "Confirmação enviada", papel: "Lembrete",
        conteudo: { layout: "conclusao", mensagem: "Seu horário está confirmado para amanhã às 14h ✂️", meta: "lembrete automático", destaque: "1h antes" },
      },
    ],
  },

  /* =========================== ORDEM DE SERVIÇO =========================== */
  {
    id: "assistencia",
    nome: "Assistência Técnica",
    icone: "Wrench",
    descricao: "Da entrada do aparelho à retirada.",
    etapas: [
      {
        id: "cliente", tipo: "cliente", icone: "MessageCircle",
        titulo: "Cliente relata o defeito",
        conteudo: { layout: "conversa", autor: "Carlos M.", hora: "09:07", mensagem: "Meu celular não está carregando." },
      },
      {
        id: "ia", tipo: "ia", icone: "Bot",
        titulo: "IA abre a OS",
        conteudo: {
          layout: "resposta",
          resposta: "Entendi. Já estou abrindo seu atendimento.",
          etiquetas: ["iPhone 12", "Não carrega"],
        },
      },
      {
        id: "sistema", tipo: "sistema", icone: "Stethoscope",
        titulo: "Diagnóstico", papel: "Bancada",
        conteudo: {
          layout: "checklist",
          itens: [
            { nome: "Bateria", status: "ok" },
            { nome: "Conector de carga", status: "alerta" },
            { nome: "Carregador", status: "ok" },
          ],
        },
      },
      {
        id: "decisao", tipo: "decisao", icone: "GitBranch",
        titulo: "Precisa de orçamento?",
        conteudo: {
          layout: "decisao",
          saidas: [
            { rotulo: "sim", destino: "Envia para aprovação", positivo: true },
            { rotulo: "não", destino: "Resolve na hora", positivo: false },
          ],
        },
      },
      {
        id: "acao", tipo: "acao", icone: "Receipt",
        titulo: "Orçamento aprovado", papel: "Orçamento",
        conteudo: {
          layout: "ficha",
          titulo: "Orçamento #2048",
          valor: "R$ 180,00",
          linhas: [{ rotulo: "Serviço", valor: "Troca do conector" }],
          status: "Aprovado pelo cliente",
        },
      },
      {
        id: "alternativa", tipo: "ia", icone: "RefreshCw",
        titulo: "Resolve sem custo",
        conteudo: { layout: "resposta", resposta: "Era só sujeira no conector. Limpamos, sem cobrança." },
      },
      {
        id: "humano", tipo: "humano", icone: "Wrench",
        titulo: "Técnico executa", papel: "Bancada",
        conteudo: { layout: "notificacao", notificacao: "Reparo liberado", detalhe: "OS #2048 — Troca do conector", status: "Em execução", equipe: ["RT"] },
      },
      {
        id: "sucesso", tipo: "sucesso", icone: "PackageCheck",
        titulo: "Aparelho pronto", papel: "OS encerrada",
        conteudo: { layout: "conclusao", mensagem: "Aparelho pronto! Pode retirar 🔧", meta: "OS #2048", destaque: "finalizada" },
      },
    ],
  },

  /* ========================= AGENDAMENTO DE SERVIÇO ========================= */
  {
    id: "lava_jato",
    nome: "Lava Jato",
    icone: "Car",
    descricao: "Da escolha do serviço à entrega do carro.",
    etapas: [
      {
        id: "cliente", tipo: "cliente", icone: "MessageCircle",
        titulo: "Cliente pede horário",
        conteudo: { layout: "conversa", autor: "Marcos A.", hora: "16:28", mensagem: "Quero lavar meu carro amanhã." },
      },
      {
        id: "ia", tipo: "ia", icone: "Bot",
        titulo: "IA monta o serviço",
        conteudo: {
          layout: "opcoes",
          pergunta: "Qual serviço você deseja?",
          opcoes: [{ nome: "Simples" }, { nome: "Completa", escolhida: true }, { nome: "Polimento" }],
        },
      },
      {
        id: "sistema", tipo: "sistema", icone: "CalendarDays",
        titulo: "Verifica os boxes", papel: "Fila",
        conteudo: {
          layout: "agenda",
          cabecalho: "Lavagem completa",
          profissional: "Box 2",
          horarios: [
            { hora: "09:00" },
            { hora: "10:00", alvo: true },
            { hora: "11:00", livre: false },
            { hora: "14:00" },
          ],
        },
      },
      {
        id: "decisao", tipo: "decisao", icone: "GitBranch",
        titulo: "Tem box no horário?",
        conteudo: {
          layout: "decisao",
          saidas: [
            { rotulo: "sim", destino: "Reserva o box", positivo: true },
            { rotulo: "não", destino: "Sugere outro", positivo: false },
          ],
        },
      },
      {
        id: "acao", tipo: "acao", icone: "CalendarCheck",
        titulo: "Reserva confirmada", papel: "Reserva",
        conteudo: {
          layout: "ficha",
          titulo: "Lavagem completa",
          valor: "R$ 80,00",
          linhas: [{ rotulo: "Quando", valor: "Amanhã, 10:00" }],
          status: "Box 2 reservado",
        },
      },
      {
        id: "alternativa", tipo: "ia", icone: "RefreshCw",
        titulo: "Sugere outro horário",
        conteudo: { layout: "resposta", resposta: "10h lotou. Consigo às 09:00 ou 14:00, tudo bem?" },
      },
      {
        id: "humano", tipo: "humano", icone: "Droplets",
        titulo: "Equipe executa", papel: "Box 2",
        conteudo: { layout: "notificacao", notificacao: "Novo serviço agendado", detalhe: "Lavagem completa — 10:00", status: "Em execução", equipe: ["EQ"] },
      },
      {
        id: "sucesso", tipo: "sucesso", icone: "Car",
        titulo: "Carro entregue", papel: "Concluído",
        conteudo: { layout: "conclusao", mensagem: "Seu carro está pronto! Pode buscar 🚗", meta: "atendido em", destaque: "50 min", avaliacao: 5 },
      },
    ],
  },
];
